module.exports = __webpack_public_path__ + "images/fa-bf-hero-title.webp";